<template>
  <div v-if="is_open">
    <div class="gallery-overlay">
      <div class="gallery-container photo-crop">
        <div class="gallery-container__header">
            <h5 class="position-relative">{{ $t('listing_form.crop.crop_and_resize_photo') }}</h5>
            <a class="button-close" @click.prevent="clear()"><img src="/img/close.svg" alt="close" class="close-icon"></a>
        </div>
        <p class="text-primary gallery-container__description">{{ $t('listing_form.crop.adjust_your') }}</p>
        <div class="crop-container__body">
           <div id="croppie-container"></div>
        </div>

        <div class="gallery-container__footer d-flex">
            <button class="ml-auto button button-m button-secondary mr-16" @click.prevent="clear()">{{ $t('common.cancel') }}</button>
            <a-spin :spinning="is_loading">
            <button class="button button-m button-primary" @click.prevent="crop()">{{ $t('listing_form.crop.crop') }}</button>
            </a-spin>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                is_loading: false,
                is_open: false,
                photo: null,
                croppie: null,
                type: null,
                viewport: null
            }
        },
        mounted() {
            
        },
        methods: {
            crop() {
                this.is_loading = true;

                this.croppie.result({type: 'blob', size: 'original', format: 'jpeg', quality: 0.75}).then(function(blob) {
                    const url = `/api/photos/${this.photo.id}`

                    let formData = new FormData();
                    formData.append('photo', blob);

                    axios.post(url, formData)
                        // get data
                        .then(function (response) {
                            this.$emit('cropped', this.type, response.data.data.photo);
                            this.clear();                 
                        }.bind(this));

                }.bind(this))
                .catch(e => {
                    this.is_loading = false;
                    this.$toastr.error("Unknown error occured. Please contact our support");
                });
            },
            clear() {
                this.is_loading = false;
                this.is_open = false;
                this.type = null;
                this.photo = null;
                this.viewport = null;
                this.croppie.destroy();
            },
            initCroppie() {
                this.$nextTick(function () {
                    var el = document.getElementById('croppie-container');

                    this.croppie = new Croppie(el, {
                        viewport: { width: this.viewport.width, height: this.viewport.height },
                        enableOrientation: true
                    });

                    this.croppie.bind({
                        url: this.photo.full_path,
                    });
                });
            },
            getListingPhotos() {
                // let url =  `/api/photos/get-listing/${this.listing_id}`;

                // return axios.get(url)
                //     // get data
                //     .then(function (response) {
                //         // handle success
                //         this.photos = response.data.data.photos;
                //     }.bind(this));
            }
        },
        watch: {
            is_open: function(newValue, oldValue) {
                if (newValue === true) {
                    this.initCroppie();
                }
            }
        }
    }
</script>
